import { render } from "./faq.vue?vue&type=template&id=104c84bd&scoped=true&ts=true"
import script from "./faq.vue?vue&type=script&lang=ts"
export * from "./faq.vue?vue&type=script&lang=ts"

import "./faq.vue?vue&type=style&index=0&id=104c84bd&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-104c84bd"]])

export default __exports__